import { Outlet } from 'react-router-dom';
import { NavigationConfirmationModal } from '@/components';
import { useGlobalStore } from '@/stores/globalStore';
import { useNavigationStore } from '@/stores/navigationStore';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

function App() {
    const darkMode = useGlobalStore(state => state.darkMode);
    const { showConfirmation, cancelNavigation, proceedWithNavigation } = useNavigationStore();

    // Apply theme class to document element for proper CSS cascade
    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('theme-dark');
            document.documentElement.classList.remove('theme-light');
        } else {
            document.documentElement.classList.add('theme-light');
            document.documentElement.classList.remove('theme-dark');
        }
    }, [darkMode]);

    return (
        <div className='font-default antialiased'>
            <ToastContainer toastClassName='stan-toast-container' />

            <Outlet />

            {/* Global Navigation Confirmation Modal */}
            <NavigationConfirmationModal
                isOpen={showConfirmation}
                onStay={cancelNavigation}
                onDiscard={proceedWithNavigation}
            />
        </div>
    );
}

export default App;
